import React from 'react';
import { withRouter } from 'react-router-dom';
import * as PATH from '../lib/routes/path';

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      sessionStorage.prevUrl = prevProps.location.pathname;
      if (
        this.props.location.pathname !== PATH.SIGNIN &&
        this.props.location.pathname !== PATH.SIGNIN_NAVER &&
        this.props.location.pathname !== PATH.SIGNUP
      ) {
        sessionStorage.nPrevUrl = this.props.location.pathname;
      }

      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(ScrollToTop);
